import { Blackjack } from '../../features/games/blackjack/Blackjack';
import { useGameConfig } from './gamePageHelpers';
import { Spinner } from '../../components/Spinner';

export function BlackjackPage() {
  const { isLoading, enabled, minBet, maxBet } = useGameConfig('blackjack');
  if (isLoading) return <Spinner full />;

  return (
    <div className="space-y-6">
      <h1 className="text-center text-3xl font-bold text-gold">🃏 Blackjack</h1>
      {enabled ? (
        <Blackjack minBet={minBet} maxBet={maxBet} />
      ) : (
        <p className="text-center text-slate-400">
          This game is currently unavailable.
        </p>
      )}
    </div>
  );
}
